import { CheckCircle2, AlertTriangle, TrendingUp } from 'lucide-react';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

import type { CampaignReview } from '@/hooks/useReviews';

export const ReviewStatistics = ({ review }: { review: CampaignReview }) => {
  const totalCalls = review.total_calls || 0;
  const reviewedCalls = review.reviewed_calls || 0;
  const callsWithIssues = review.calls_with_issues || 0;

  const accuracy =
    totalCalls > 0 ? Math.round(((totalCalls - callsWithIssues) / totalCalls) * 100) : 0;

  const stats = [
    {
      title: 'Total Calls Reviewed',
      value: reviewedCalls,
      icon: CheckCircle2,
      color: 'text-blue-600 dark:text-blue-400',
      bgColor: 'bg-blue-100 dark:bg-blue-900/50',
    },
    {
      title: 'Calls with Issues',
      value: callsWithIssues,
      icon: AlertTriangle,
      color: 'text-amber-600 dark:text-amber-400',
      bgColor: 'bg-amber-100 dark:bg-amber-900/50',
    },
    {
      title: 'Calls Matching',
      value: totalCalls - callsWithIssues,
      icon: CheckCircle2,
      color: 'text-emerald-600 dark:text-emerald-400',
      bgColor: 'bg-emerald-100 dark:bg-emerald-900/50',
    },
    {
      title: 'Accuracy Rate',
      value: `${accuracy}%`,
      icon: TrendingUp,
      color:
        accuracy >= 90
          ? 'text-emerald-600 dark:text-emerald-400'
          : accuracy >= 70
            ? 'text-amber-600 dark:text-amber-400'
            : 'text-rose-600 dark:text-rose-400',
      bgColor:
        accuracy >= 90
          ? 'bg-emerald-100 dark:bg-emerald-900/50'
          : accuracy >= 70
            ? 'bg-amber-100 dark:bg-amber-900/50'
            : 'bg-rose-100 dark:bg-rose-900/50',
    },
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {stats.map((stat) => (
        <Card key={stat.title}>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">{stat.title}</CardTitle>
            <div className={`rounded-full p-2 ${stat.bgColor}`}>
              <stat.icon className={`h-4 w-4 ${stat.color}`} />
            </div>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{stat.value}</div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
